import type * as React from "react";

const SvgLoadErrorVector = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x={0}
    y={0}
    viewBox="0 0 200 160"
    xmlSpace="preserve"
    {...props}
  >
    <title>Error</title>
    <style>
      {
        ".LoadErrorVector_svg__st2{fill:#e0e0e0}.LoadErrorVector_svg__st4{fill:#b2b4b5}"
      }
    </style>
    <image
      width={174}
      height={108}
      xlinkHref="B0BD20275AF291D4.png"
      transform="translate(13 37)"
      overflow="visible"
      opacity={0.08}
    />
    <path
      d="M172.1 42L20 57.2l7.9 78.9L180 120.9 172.1 42zM66.5 65.2c-1.4.1-2.7-.9-2.9-2.4-.1-1.4.9-2.7 2.4-2.9 1.4-.1 2.7.9 2.9 2.4s-.9 2.7-2.4 2.9zm61.6-6.2c-1.4.1-2.7-.9-2.9-2.4-.1-1.4.9-2.7 2.4-2.9 1.4-.1 2.7.9 2.9 2.4.1 1.4-1 2.7-2.4 2.9z"
      fill="#fff"
    />
    <path
      d="M172.1 42L20 57.2l7.9 78.9L180 120.9 172.1 42zM66.5 65.2c-1.4.1-2.7-.9-2.9-2.4-.1-1.4.9-2.7 2.4-2.9 1.4-.1 2.7.9 2.9 2.4s-.9 2.7-2.4 2.9zm61.6-6.2c-1.4.1-2.7-.9-2.9-2.4-.1-1.4.9-2.7 2.4-2.9 1.4-.1 2.7.9 2.9 2.4.1 1.4-1 2.7-2.4 2.9z"
      fill="none"
      stroke="#e0e0e0"
      strokeMiterlimit={10}
    />
    <path
      className="LoadErrorVector_svg__st2"
      d="M127.8 57.1c-.2 0-.4-.1-.5-.2L99.5 28.8c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0l27.8 28.1c.3.3.3.8 0 1.1-.2.1-.4.2-.6.2zM66.3 63.3c-.2 0-.4-.1-.5-.2-.3-.3-.3-.7-.1-1.1l27.6-31.7c.3-.3.7-.3 1.1-.1.3.3.3.7.1 1.1L66.8 63c-.1.2-.3.3-.5.3z"
    />
    <circle
      cx={97}
      cy={30.9}
      r={7}
      fill="#fff"
      stroke="#e0e0e0"
      strokeMiterlimit={10}
    />
    <g>
      <path
        className="LoadErrorVector_svg__st4"
        d="M57.3 84.8c2.4 2.2 3.8 5.4 4.2 9.8.5 4.8-.3 8.6-2.4 11.4-2.1 2.9-5.3 4.5-9.5 4.9-3.9.4-7.1-.5-9.5-2.7-2.4-2.2-3.8-5.5-4.3-10-.5-4.7.3-8.5 2.4-11.2 2.1-2.8 5.3-4.4 9.5-4.8 4-.5 7.2.4 9.6 2.6zm-12.8 4.1c-.8.6-1.3 1.5-1.5 2.8-.3 1.2-.3 2.9-.1 4.9.2 2.4.6 4.3 1.1 5.7.5 1.4 1.2 2.3 2.1 2.8.9.5 2 .7 3.4.6 1.4-.1 2.4-.5 3.2-1.1.7-.6 1.2-1.5 1.5-2.8.2-1.2.3-2.9 0-5-.2-2.4-.6-4.3-1.1-5.6-.5-1.3-1.2-2.3-2.1-2.8-.9-.5-2-.7-3.4-.5-1.3 0-2.3.4-3.1 1zM85.1 82c2.4 2.2 3.8 5.4 4.2 9.8.5 4.8-.3 8.6-2.4 11.4-2.1 2.9-5.3 4.5-9.5 4.9-3.9.4-7.1-.5-9.5-2.7-2.4-2.2-3.8-5.5-4.3-10-.5-4.7.3-8.5 2.4-11.2 2.1-2.8 5.3-4.4 9.5-4.8 4-.5 7.2.4 9.6 2.6zm-12.7 4.1c-.8.6-1.3 1.5-1.5 2.8-.3 1.2-.3 2.9-.1 4.9.2 2.4.6 4.3 1.1 5.7.5 1.4 1.2 2.3 2.1 2.8.9.5 2 .7 3.4.6 1.4-.1 2.4-.5 3.2-1.1.7-.6 1.2-1.5 1.5-2.8.2-1.2.3-2.9 0-5-.2-2.4-.6-4.3-1.1-5.6-.5-1.4-1.1-2.4-2-2.9-.9-.5-2-.7-3.4-.5-1.4.1-2.5.5-3.2 1.1zM110.6 78.5c1.8 1.3 2.8 3.4 3.1 6.1.2 2.2-.1 4.1-.9 5.8-.8 1.7-2.1 3.1-3.8 4.2-1.7 1.1-3.7 1.7-6.1 2l-2.5.3 1.1 8.4-7 .7-.4-8.3-2.4-19.5 11.7-1.2c3-.4 5.4.1 7.2 1.5zm-4.7 10.8c.4-.9.6-2 .5-3.3-.1-1.4-.6-2.5-1.4-3.1-.8-.6-1.9-.9-3.4-.8l-2.3.4.7 9.1 3.7-.2c1-.5 1.8-1.2 2.2-2.1zM133.5 75l-.5 6-1 .5c-1.2-.6-2.3-1.1-3.4-1.4-1.1-.3-2.1-.4-2.9-.3-.9.1-1.7.4-2.2.9-.5.5-.7 1.1-.7 1.7.1.7.5 1.3 1.2 1.7.8.4 1.9.9 3.5 1.5 1.7.6 3 1.1 4.1 1.7 1.1.5 2 1.3 2.8 2.2.8 1 1.3 2.2 1.5 3.7.2 1.7-.1 3.2-.9 4.7-.8 1.4-1.9 2.6-3.5 3.6s-3.5 1.5-5.7 1.8c-2.9.3-5.8 0-8.8-.9l.4-6.3.7-.5c1.3.9 2.7 1.5 4.2 2 1.5.4 2.7.6 3.8.5 1.1-.1 1.9-.4 2.4-1 .5-.5.7-1.1.7-1.8-.1-.8-.5-1.4-1.3-1.8-.8-.4-1.9-.9-3.5-1.5s-3-1.1-4-1.6c-1.1-.5-2-1.3-2.8-2.2-.8-1-1.3-2.2-1.5-3.7-.2-1.7.1-3.3.9-4.7.8-1.5 1.9-2.7 3.5-3.6 1.5-.9 3.4-1.5 5.5-1.7 2.3-.5 4.8-.2 7.5.5zM143.5 95c.6.5 1 1.3 1.1 2.4.1 1.1-.1 2.1-.7 2.8-.6.7-1.4 1.2-2.5 1.3-1.1.1-2-.1-2.6-.7-.6-.5-1-1.4-1.1-2.5-.1-1.1.1-2 .7-2.8.6-.7 1.4-1.2 2.5-1.3 1.1.1 2 .3 2.6.8zM153.3 94c.6.5 1 1.3 1.1 2.4.1 1.1-.1 2.1-.7 2.8-.6.7-1.4 1.2-2.5 1.3-1.1.1-2-.1-2.6-.7-.6-.5-1-1.4-1.1-2.5-.1-1.1.1-2 .7-2.8.6-.7 1.4-1.2 2.5-1.3 1.1.1 2 .3 2.6.8zM163.1 93c.6.5 1 1.3 1.1 2.4.1 1.1-.1 2.1-.7 2.8-.6.7-1.4 1.2-2.5 1.3-1.1.1-2-.1-2.6-.7-.6-.5-1-1.4-1.1-2.5-.1-1.1.1-2 .7-2.8.6-.7 1.4-1.2 2.5-1.3 1.1.1 2 .3 2.6.8z"
      />
    </g>
  </svg>
);

export default SvgLoadErrorVector;
